// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Wk","contentWrapCtaDefault":"Xk","disabled":"Yk","contentWrapCtaWhite":"Zk","promos":"_k","lazyPromo":"al","mainContent":"bl","headingText":"cl","copy":"dl","subtext":"el"};